import App from './components/app/App';
import React from 'react';
import { WORKFLOW_ACCESS } from '../../global/app-global-values';

const Workflows = () => <App />;

export default {
  routeProps: {
    path: '/workflows',
    component: Workflows,
  },
  name: 'Workflows',
  label: 'Workflows',
  iconClassName: 'icon-loop',
  active: true,
  accessGroup: WORKFLOW_ACCESS,
};
